module.exports = __webpack_public_path__ + "static/media/pepsbacker.ef67176c.gif";